import { LoadingOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import { inject, observer } from 'mobx-react'
import date_format from '../../date_format'
import common_history_log from '../../enum_utils'
import utils from '../../utils'
import DiffTable from './DiffTable/DiffTable'
import { ListHistoryLogModalWrapper } from './ListHistoryLogModalStyled'
import { toJS } from 'mobx'

const ListHistoryLogModal = props => {
  const {
    type,
    taskInfo,
    isVisible,
    handleCloseHistory,
    listHistoryLogStore,
    riskDetail,
  } = props

  const { list, isLoading, message } = listHistoryLogStore

  useEffect(() => {
    if (!taskInfo.code) {
      return
    }

    try {
      listHistoryLogStore.getList(taskInfo.code)
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra')
    }

    return () => {
      listHistoryLogStore.clear()
    }
  }, [taskInfo])

  return (
    <>
      <ListHistoryLogModalWrapper
        title={'Lịch sử'}
        width={1300}
        style={{ top: 40 }}
        visible={isVisible}
        closable={true}
        maskClosable={true}
        onCancel={handleCloseHistory}
        footer={null}
        wrapClassName="custom-modal-wrapper">
        <div>
          {isLoading && (
            <LoadingOutlined style={{ marginLeft: 10 }} spin={true} />
          )}
          {message && <p>{message}</p>}
          {
            <ul>
              {list &&
                list?.map((item, index) => {
                  // console.log('🚀 ~ ListHistoryLogModal ~ list:', toJS(list))
                  return (
                    <li key={index} style={{ marginBottom: 16 }}>
                      <span style={{ marginBottom: 8, display: 'block' }}>
                        <b>{common_history_log.enumToText(item.action)}</b> lúc
                        <span>
                          {' '}
                          {date_format.HH_mm_DD_MM_YYYY(item.processed_date)}
                        </span>{' '}
                        bởi
                        <b>
                          {' '}
                          {utils.getNameInCapitalize(item.user.name_uppercase)}
                        </b>
                      </span>
                      {/* nếu không có thay đổi(không có data_after) thì không cần hiển thị table */}
                      {item?.data_after && (
                        <DiffTable
                          riskDetail={riskDetail}
                          key={item.id}
                          dataBefore={item.data_before}
                          dataAfter={item.data_after}
                          type={type}
                        />
                      )}
                    </li>
                  )
                })}
            </ul>
          }
        </div>
      </ListHistoryLogModalWrapper>
    </>
  )
}

ListHistoryLogModal.propTypes = {
  type: PropTypes.string,
  isVisible: PropTypes.bool,
  handleCloseHistory: PropTypes.func,
  taskInfo: PropTypes.any,
}

export default inject('listHistoryLogStore')(observer(ListHistoryLogModal))
